/** Serialized document-retrieval view returned by product-service APIs. */
export type DocumentRetrievalStatus = "processing" | "ready" | "failed";

export const TRANSIENT_DOCUMENT_RETRIEVAL_STATUSES: ReadonlySet<DocumentRetrievalStatus> =
  new Set(["processing"]);

export const FAILED_DOCUMENT_RETRIEVAL_STATUSES: ReadonlySet<DocumentRetrievalStatus> =
  new Set(["failed"]);

export interface DocumentRetrieval {
  readonly latestRetrievalVersion: number;
  readonly activeRetrievalVersion: number | null;
  readonly status: DocumentRetrievalStatus;
  readonly failureCode: string | null;
  readonly retryable: boolean;
  readonly chunkCount: number | null;
  readonly profileVersion: string;
  readonly updatedAt: string;
}
